import React, { useState, useEffect } from "react";
import Line from "../../../assets/line2.svg";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

import img1 from "../../../assets/user4.jpeg";
import img2 from "../../../assets/user2.jpeg";
import img3 from "../../../assets/user5.jpeg";

const testimonials = [
  {
    name: "Alex Johnson",
    location: "Sales Director at TechSolutions",
    feedback:
      "ExactMail.io has significantly improved our outreach efficiency. Always impressed with the accuracy rate.",
      image: img1
  },
  {
    name: "Maria Rodriguez",
    location: "Talent Acquisition at GlobalCorp",
    feedback:
      "Finding and verifying candidate emails has never been easier. A game-changer for our recruitment process.",
      image: img2
  },
  {
    name: "Liam Smith",
    location: "Marketing Manager at GrowthHackers Inc.",
    feedback:
      "Our email campaigns now have higher engagement rates thanks to ExactMail.io's reliable data.",
      image: img3
  },
];

export default function Slider() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCards, setVisibleCards] = useState(getVisibleCards());
  const [transitioning, setTransitioning] = useState(false);

  function getVisibleCards() {
    if (window.innerWidth >= 1024) return 3;
    if (window.innerWidth >= 768) return 2;
    return 1;
  }

  const handleNext = () => {
    setTransitioning(true);
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const handlePrevious = () => {
    setTransitioning(true);
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const displayedTestimonials = [];
  for (let i = 0; i < visibleCards; i++) {
    displayedTestimonials.push(
      testimonials[(currentIndex + i) % testimonials.length]
    );
  }

  useEffect(() => {
    const handleResize = () => {
      const newVisibleCards = getVisibleCards();
      setVisibleCards(newVisibleCards);
      setCurrentIndex(0);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTransitioning(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [currentIndex]);

  return (
    <div className="bg-white pt-4 pb-10 px-5 xl:px-3 flex flex-col items-center">
      <div className="text-center w-full mb-8 mt-2 lg:mt-12">
        <h2 className="text-3xl sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold">
        Trusted by{" "}
          <span className="relative inline-block">
          Professionals 
            <img
              src={Line}
              alt="Underline decoration"
              className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
            />
          </span>{" "}
          Worldwide
        </h2>
      </div>
      <div className="flex items-center mt-8">
        <button onClick={handlePrevious} className="text-blue-500 text-2xl">
          <FaChevronLeft />
        </button>
        <div className="flex gap-4 min-[400px]:mx-4 xl:mx-8">
          {displayedTestimonials.map((testimonial, index) => (
            <div
              key={index}
              className={`bg-[#ecf3ff] p-6 lg:p-10 rounded-md shadow-md min-[400px]:w-full w-[260px] max-w-md flex flex-col justify-between h-[300px] testimonial ${
                transitioning ? "" : "show"
              }`}
            >
              <div>
                <img
                  src={testimonial.image}
                  alt="Testimonial"
                  className="object-cover w-20 h-20 mb-5 -mt-4 rounded-full"
                />
              </div>
              <p className="italic text-gray-800 text-md mb-4">
                {testimonial.feedback}
              </p>
              <div className="mt-auto">
                <h3 className="text-[#15233F] font-bold">{testimonial.name}</h3>
                <p className="text-gray-500 text-sm font-bold">
                  {testimonial.location}
                </p>
              </div>
            </div>
          ))}
        </div>
        <button onClick={handleNext} className="text-blue-500 text-2xl">
          <FaChevronRight />
        </button>
      </div>
    </div>
  );
}
